import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { API, createSession, getUsers } from "../Services/api";
import * as dotenv from 'dotenv';
dotenv.config();

export const AuthContext = createContext();

const baseUrl = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const recoveredUser = localStorage.getItem("user");

    if (recoveredUser) {
      setUser(JSON.parse(recoveredUser));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await createSession(username, password);
    const newUser = await getUsers(response.data.users);
    const loggedUser = newUser.find((user) => user.username === username);
    console.log(newUser);
    
    console.log("login", response.data);

    console.log("loggedUser", loggedUser);
    const token = response.data.access_token;
    console.log("token", token);

    localStorage.setItem('user', JSON.stringify(loggedUser));
    localStorage.setItem('token', token);

    API.defaults.headers.Authorization = `Bearer ${token}`;
      setUser(loggedUser);
      navigate('/');
  };

  const SignUp = async (name, email, usertype, photo, password, confirmPassword) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, usertype, photo, password, confirmPassword})
    };

    fetch(baseUrl, requestOptions)
      .then(response => response.json())
      .then(data => console.log(data));  

  };

  const logout = () => {
    console.log('logout');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    API.defaults.headers.Authorization = null;

    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ authenticated:!!user, user, login,
    logout, loading, SignUp }}>
      {children}
    </AuthContext.Provider>
  );
}
